const locale: Record<string, string> = {
  'editor.remove': 'Remove',
  'editor.copy': 'Copy',
  'editor.words': 'WORDS',
  'editor.characters': 'CHARACTERS',
  'editor.default': 'Default',
  'editor.recent': 'Recently Used',
  'editor.nofill': 'Remove Color',
  'editor.format': 'Format Painter',
  'editor.close': 'Close',
  'editor.modify': 'Modify',
  'editor.preview.tooltip': 'Preview',
  'editor.draghandle.tooltip': 'Click And Drag',
  'editor.copyToClipboard': 'CopyToClipboard',
  'editor.importWord.tooltip': 'Import from Word',
  'editor.importWord.success': 'Import Success',
  'editor.importWord.fileTooLarge': 'File is Too large',
  'editor.importWord.error': 'Import Failed, File not supported',
  'editor.slash': "Press '/' for commands",
  'editor.slash.empty': 'No Result',
  'editor.slash.format': 'Format',
  'editor.slash.insert': 'Insert',
  'editor.slash.embed': 'Embed Services',
  'editor.content': 'Please input content',
  'editor.moremark': 'More Text Styles',
  'editor.size.small.tooltip': 'Small',
  'editor.size.medium.tooltip': 'Medium',
  'editor.size.large.tooltip': 'Cover',
  'editor.bold.tooltip': 'Bold',
  'editor.italic.tooltip': 'Italic',
  'editor.underline.tooltip': 'Underline',
  'editor.strike.tooltip': 'Strike',
  'editor.color.tooltip': 'Color',
  'editor.color.more': 'Color Picker',
  'editor.highlight.tooltip': 'Highlight',
  'editor.lineheight.tooltip': 'Line Height',
  'editor.heading.tooltip': 'Headings',
  'editor.heading.h1.tooltip': 'Heading 1',
  'editor.heading.h2.tooltip': 'Heading 2',
  'editor.heading.h3.tooltip': 'Heading 3',
  'editor.heading.h4.tooltip': 'Heading 4',
  'editor.heading.h5.tooltip': 'Heading 5',
  'editor.heading.h6.tooltip': 'Heading 6',
  'editor.paragraph.tooltip': 'Paragraph',
  'editor.textalign.tooltip': 'Align',
  'editor.textalign.left.tooltip': 'Left',
  'editor.textalign.center.tooltip': 'Center',
  'editor.textalign.right.tooltip': 'Right',
  'editor.textalign.justify.tooltip': 'Justify',
  'editor.indent': 'Indent',
  'editor.indent.indent': 'Increase Indent',
  'editor.indent.outdent': 'Decrease Indent',
  'editor.fontFamily.tooltip': 'Font family',
  'editor.fontFamily.default': 'Default',
  'editor.fontSize.tooltip': 'Font size',
  'editor.fontSize.default.tooltip': 'Default',
  'editor.superscript.tooltip': 'Superscript',
  'editor.subscript.tooltip': 'Subscript',
  'editor.bulletlist.tooltip': 'Bullet List',
  'editor.bulletlist.disc.tooltip': 'Disc',
  'editor.bulletlist.circle.tooltip': 'Circle',
  'editor.bulletlist.square.tooltip': 'Square',
  'editor.orderedlist.tooltip': 'Ordered List',
  'editor.orderedlist.decimal.tooltip': 'Decimal',
  'editor.orderedlist.decimalLeadingZero.tooltip': 'Decimal with leading zero',
  'editor.orderedlist.lowerRoman.tooltip': 'Lower Roman',
  'editor.orderedlist.upperRoman.tooltip': 'Upper Roman',
  'editor.orderedlist.lowerLatin.tooltip': 'Lower Latin',
  'editor.orderedlist.upperLatin.tooltip': 'Upper Latin',
  'editor.orderedlist.tradChineseInformal.tooltip': 'Trad Chinese Informal',
  'editor.orderedlist.simpChineseFormal.tooltip': 'Simp Chinese Informal',
  'editor.tasklist.tooltip': 'Task List',
  'editor.indent.tooltip': 'Indent',
  'editor.outdent.tooltip': 'Outdent',
  'editor.columns.tooltip': 'Columns',
  'editor.link.tooltip': 'Link',
  'editor.link.unlink.tooltip': 'UnLink',
  'editor.link.open.tooltip': 'Open Link',
  'editor.link.edit.tooltip': 'Edit Link',
  'editor.link.dialog.title': 'Insert Link',
  'editor.link.dialog.link': 'Link',
  'editor.link.dialog.text': 'Text',
  'editor.link.dialog.openInNewTab': 'Open In New Tab',
  'editor.link.dialog.link.placeholder': 'Link Address',
  'editor.link.dialog.text.placeholder': 'Add Description',
  'editor.link.dialog.button.apply': 'Apply',
  'editor.image.tooltip': 'Image',
  'editor.image.menu.flipX': 'Flip vertical',
  'editor.image.menu.flipY': 'Flip horizontal',
  'editor.image.menu.size': 'Set Size',
  'editor.image.menu.size.width': 'Width',
  'editor.image.menu.size.height': 'Height',
  'editor.image.dragger.tooltip': 'Click or drag the image to the area to upload',
  'editor.image.float.left.tooltip': 'Float left',
  'editor.image.float.none.tooltip': 'Float none',
  'editor.image.float.right.tooltip': 'Float right',
  'editor.image.dialog.title': 'Add an image',
  'editor.image.dialog.tab.url': 'Url',
  'editor.image.dialog.tab.upload': 'Upload',
  'editor.image.dialog.uploading': 'Uploading',
  'editor.image.dialog.form.link': 'Link',
  'editor.image.dialog.placeholder': 'Link',
  'editor.image.dialog.form.alt': 'Alt',
  'editor.image.dialog.form.aspectRatio': 'Lock original aspect ratio',
  'editor.image.dialog.form.file': 'File',
  'editor.image.dialog.button.apply': 'Apply',
  'editor.video.tooltip': 'Video',
  'editor.video.dialog.tab.upload': 'Upload',
  'editor.video.dialog.uploading': 'Uploading',
  'editor.video.dialog.title': 'Embed or upload a video',
  'editor.video.dialog.link': 'link',
  'editor.video.dialog.placeholder': 'Link',
  'editor.video.dialog.button.apply': 'apply',
  'editor.table.tooltip': 'Table',
  'editor.table.menu.insert_table': 'Insert Table',
  'editor.table.menu.insert_table.with_header_row': 'With header row',
  'editor.table.menu.insertColumnBefore': 'Insert Column Before',
  'editor.table.menu.insertColumnAfter': 'Insert Column After',
  'editor.table.menu.deleteColumn': 'Delete Column',
  'editor.table.menu.insertRowAbove': 'Insert Row Above',
  'editor.table.menu.insertRowBelow': 'Insert Row Below',
  'editor.table.menu.deleteRow': 'Delete Row',
  'editor.table.menu.mergeCells': 'Merge Cells',
  'editor.table.menu.splitCells': 'Split Cells',
  'editor.table.menu.deleteTable': 'Delete Table',
  'editor.table.menu.setCellsBgColor': 'Cell Background Color',
  'editor.blockquote.tooltip': 'Blockquote',
  'editor.horizontalrule.tooltip': 'Horizontal Rule',
  'editor.code.tooltip': 'Code',
  'editor.codeblock.tooltip': 'Code Block',
  'editor.clear.tooltip': 'Clear Format',
  'editor.undo.tooltip': 'Undo',
  'editor.redo.tooltip': 'Redo',
  'editor.fullscreen.tooltip.fullscreen': 'Fullscreen',
  'editor.fullscreen.tooltip.exit': 'Fullscreen Exit',
  'editor.imageUpload.fileTypeNotSupported': 'File type not supported',
  'editor.imageUpload.fileSizeTooBig': 'File size too big, Maximum size is',
  'editor.AI.placeholder': 'Ask AI ...',
  'editor.AI.generating': 'Generating',
  'editor.AI.insert': 'Insert below selection',
  'editor.AI.replace': 'Replace selected content',
  'editor.AI.regenerate': 'Regenerate',
  'editor.AI.close': 'Close',
  'editor.AI.stop': 'Stop',
  'editor.AI.ask': 'Ask AI',
  'editor.menubar.file': 'File',
  'editor.menubar.edit': 'Edit',
  'editor.menubar.view': 'View',
  'editor.menubar.insert': 'Insert',
  'editor.menubar.format': 'Format',
  'editor.menubar.menu.newDoc': 'New Document',
  'editor.menubar.menu.restoreLastDraft': 'Restore last draft',
  'editor.menubar.menu.print': 'Print',
  'editor.menubar.menu.cut': 'Cut',
  'editor.menubar.menu.copy': 'Copy',
  'editor.menubar.menu.paste': 'Paste',
  'editor.menubar.menu.pasteAsText': 'Paste as text',
  'editor.menubar.menu.selectAll': 'Select all',
  'editor.menubar.menu.preview': 'Preview',
  'editor.menubar.menu.spellCheck': 'Spell check',
  'editor.findAndReplace.tooltip': 'Find and replace',
  'editor.findAndReplace.find': 'Find',
  'editor.findAndReplace.replace': 'Replace',
  'editor.findAndReplace.replaceAll': 'Replace All',
  'editor.findAndReplace.caseSensitive': 'Case Sensitive',
  'editor.printer.tooltip': 'Print',
}

export default locale
